export const sprinklerSamplingKeys = {
    all: ['sprinkler-sampling'],
    table: (params) => ['sprinkler-sampling', 'table', params.buildingId, params],
    prepopulate: (buildingId) => ['sprinkler-sampling', 'prepopulate', buildingId]
};
export const kitOrderKeys = {
    all: ['kit-orders'],
    table: (params) => ['kit-orders', 'table', params]
};
